import {getAppSearchParams} from '~/utils/url'

export type IframeMessage = MessageEvent<
  | {
      action: 'checkOrigin' | 'previewReady' | 'openDialog' | 'closeDialog'
    }
  | {
      action: 'updateSearchParams'
      payload: string
    }
>

export const handleIframeSearchParamsUpdate = (searchString: string) => {
  const params = getAppSearchParams(searchString)
  const currentSearchParams = new URLSearchParams(window.location.search)

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null) currentSearchParams.set(key, value)
    else currentSearchParams.delete(key)
  })

  const newSearchString = currentSearchParams.toString()
  const newSearch = newSearchString ? `?${newSearchString}` : ''

  const newUrl = `${window.location.pathname}${newSearch}`
  window.history.replaceState({}, '', newUrl)
}
